import styled, { css } from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import { GuestExperienceContainer } from 'common/components/TouchpointEditor/components/TouchpointContainer';

const defaultLayoutCss = css`
    display: flex;
    flex-direction: column;
`;

const sidebarLayoutCss = css`
    display: grid;
    grid-template-columns: 1fr 25%;
`;

export const VirtualGuestExperienceContainer = styled(GuestExperienceContainer)`
    height: 100%;
    position: relative;

    ${(props) => (props.$isSidebarOpen ? sidebarLayoutCss : defaultLayoutCss)}
`;

export const FooterBlockContainer = styled.footer`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    min-height: 75px;
    padding: 1.75rem 3rem;
    ${mediaMaxWidth.medium`
        padding: 2rem 1rem;
        gap: 2rem;
        flex-direction: column;
        align-items: flex-start;
    `}
`;

export const LeftLinkContainer = styled.ul.attrs({ role: 'list' })`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 2rem;
    list-style: none;
    margin: 0;
    padding: 0;
    ${mediaMaxWidth.medium`
        gap: 2rem;
        flex-direction: column;
        align-items: flex-start;
    `}
`;

export const RightLinkContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
    ${mediaMaxWidth.medium`
        gap: 2rem;
        flex-direction: column;
        align-items: flex-start;
    `}
`;

export const EmbedPlaceholder = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => `${theme.palette.grayscale.black}cc`};
    color: ${({ theme }) => theme.palette.grayscale.gray50};
    font-weight: bold;
    gap: 0.5rem;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
`;
